<template>
  <div class="m-4 text-left">
    <div class="flex flex-row gap-2 items-center my-2">
      <button class="rounded-full bg-paleta-3" @click="volver">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="h-8 w-8 p-1" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path
            fill="currentColor"
            d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
          ></path>
        </svg>
      </button>
      <div class="text-white text-base">Datos personales</div>
    </div>
    <div class="w-full text-white">
      <form @submit.prevent="actualizar" class="pt-6 pb-4">
        <div>
          <label class="w-full" for="email">Email:</label>
          <input
            id="email"
            class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            v-model="nombreUsuario"
            type="text"
            disabled
          />
        </div>
        <div>
          <label class="w-full" for="apellido">Apellido:</label>
          <input
            id="apellido"
            class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            v-model="apellido"
            type="text"
            :disabled="!modificando"
          />
        </div>
        <div>
          <label for="nombre">Nombre:</label>
          <input
            id="nombre"
            class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            v-model="nombre"
            type="text"
            :disabled="!modificando"
          />
        </div>
        <div>
          <label for="dni">DNI:</label>
          <input
            id="dni"
            class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            v-model="dni"
            type="number"
            :disabled="!modificando"
          />
        </div>
        <div>
          <label for="telefono">Teléfono:</label>
          <input
            class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            v-model="telefono"
            type="tel"
            :disabled="!modificando"
          />
        </div>
        <button v-if="!modificando" class="bg-paleta-4 text-white font-bold mt-2 py-2 px-4 rounded justify-left" @click.prevent="modificar">
          Modificar
        </button>
        <button v-if="modificando" class="bg-paleta-3 text-white font-bold mt-2 py-2 px-4 rounded justify-left" @click.prevent="guardar">
          Guardar
        </button>
      </form>
      <div><a :href="usuario.tc" target="_blank" class="underline">Términos y condiciones</a></div>

      <!-- <div class="mt-3 font-bold">Juego responsable</div>
    <div class="flex flex-col items-start">
      <div>Juegado en la fecha: {{ usuario.jugado }}</div>
      <div>Tope monto diario: $ 5000 <button class="bg-blue-700 text-gray-200 px-2 py-1 my-1 rounded-md">Cambiar</button></div>
      <div>Cantidad de boletos en la fecha: 10</div>
      <div>Tope cantidad diaria: 50 <button class="bg-blue-700 text-gray-200 px-2 py-1 my-1 rounded-md">Cambiar</button></div>
      <div>Fecha de autorestricción: No definida <button class="bg-blue-700 text-gray-200 px-2 py-1 my-1 rounded-md">Cambiar</button></div>
    </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import usuariosService from "@/services/UsuariosService";

export default {
  data() {
    return {
      nombreUsuario: "",
      apellido: "",
      nombre: "",
      dni: "",
      telefono: "",
      modificando: false,
      fotoTemporal: ""
    };
  },
  mounted() {
    this.nombreUsuario = this.usuario.nombreUsuario;
    this.apellido = this.usuario.apellido;
    this.nombre = this.usuario.nombre;
    this.dni = this.usuario.dni;
    this.telefono = this.usuario.telefono;
  },
  methods: {
    volver() {
      this.$router.go(-1);
    },
    modificar() {
      this.modificando = true;
      this.fotoTemporal = null;
    },
    guardar() {
      const token = this.usuario.token;
      usuariosService.actualizarDatosPersonales(this.nombreUsuario, this.apellido, this.nombre, this.dni, this.telefono, "", token, response => {
        if (response.data.resultado === "OK") {
          this.$router.push("/miCuenta/solicitudExitosa");
        } else {
          // commit("actualizarDatosPersonalesError", response.data.mensaje);
        }
      });
    }
  },
  computed: {
    ...mapState({
      usuario: state => state.sesion.usuario
    })
  }
};
</script>
